import { type LocationGeocodeBatchInput, type LocationGeocodeBatchSuccess } from '@terros/common'
import { useTantalimMutation, type TantalimMutationResponse } from '../../mutation'

export function useBatchGeocodeLocations(): TantalimMutationResponse<
  LocationGeocodeBatchInput,
  LocationGeocodeBatchSuccess
> {
  return useTantalimMutation<LocationGeocodeBatchInput, LocationGeocodeBatchSuccess>({
    url: '/location/geocode/batch',
  })
}
